module.exports = __webpack_public_path__ + "img/mugs.3185d649.jpg";